import { Component, Input, OnInit } from '@angular/core';
import { AsapService } from 'app/@core/lib/asap.service';

@Component({
    selector: 'app-filter',
    templateUrl: './filter.component.html',
    providers: [AsapService]
})

export class FilterComponent implements OnInit {

    @Input() targetId;
    @Input() targetType;

    public filter;
    public filters = [];
    public loading = false;

    constructor(
        public service: AsapService
    ) {

    }

    ngOnInit(): void {
        this.getFilters();
    }

    public save(filter) {
        this.service.basePath = "api/v2/client";
        this.service.entityName = "filter-global";

        let data = {
            target_id: this.targetId,
            target_type: this.targetType,
            filter_value: filter,
        }
        this.loading = true;
        this.service.createResource(data).subscribe((response: any) => {
            console.log("response create", response);
            this.loading = false;
            this.getFilters();
        });
    }


    public getFilters() {
        this.service.basePath = "api/v2/client";
        this.service.entityName = "filter-global";
        console.log("[getFilters]", this.targetId);
        if (this.targetId) {
            this.service.getResources({ query: "search=" + btoa(`target_id=${this.targetId}`) }).subscribe((response: any) => {
                this.filters = response.data;
            });
        }
    }

    public remove(id) {
        this.service.basePath = "api/v2/client";
        this.service.entityName = "filter-global";
        this.loading = true;
        this.service.deleteResource(id).subscribe((response: any) => {
            console.log("response delete", response);
            this.loading = false;
            this.getFilters();
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/filter/filter.component.ts